module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    key: new Date().getTime(),
    staticClass: "owl-carousel"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('div', {
      staticClass: "item"
    }, [_c('div', {
      staticClass: "image",
      style: (("background-image: url(" + (item.img) + ")"))
    })])]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e67237f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/sliders/project-slider-1.vue
// module id = 389
// module chunks = 14